import { createContext, useContext, useEffect, useRef, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Home from "@/components/Home";
import Admin from "@/components/Admin";
import CaseStudy from "@/components/CaseStudy";
import Loader from "@/components/Loader";
import Cursor from "@/components/Cursor";
import LeadPopup from "@/components/LeadPopup";

const LeadContext = createContext({ openConsult: () => {} });
export const useLead = () => useContext(LeadContext);

function App() {
  const [loading, setLoading] = useState(true);
  const [consultOpen, setConsultOpen] = useState(false);
  const [consultSource, setConsultSource] = useState("consultation_popup");

  const openConsult = (source = "consultation_popup") => {
    setConsultSource(source);
    setConsultOpen(true);
  };

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <LeadContext.Provider value={{ openConsult }}>
      <div className="App cursor-none-fine">
        {loading && <Loader onDone={() => setLoading(false)} />}
        <Cursor />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/project/:slug" element={<CaseStudy />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <LeadPopup
          open={consultOpen}
          source={consultSource}
          onClose={() => setConsultOpen(false)}
        />
        <Toaster position="top-center" richColors />
      </div>
    </LeadContext.Provider>
  );
}

export default App;
